(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('listButton', function($location, resourceService, actionTemplateService) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            path: '@',
            click: '&',
            template: '='
        },
        template: `<li ng-click="onclick($event)">
                       <span ng-transclude></span>
                       <div class="template-action" ng-show="open" ng-include="templateUrl"></div>
                   </li>`,
        link(scope, el, attr) {
            const click = attr.click != null;
            const path = attr.path != null;

            scope.open = false;

            scope.getResourceValue = function(code) {
                return resourceService.get(code);
            };

            scope.onclick = function(e) {
                if (click) {
                    el.addClass('clicked');
                    scope.click({ e });
                } else if (path && scope.path) {
                    $location.path(scope.path);
                } else if (scope.template && !scope.open) {
                    scope.templateData = scope.template.Data;
                    scope.utils = actionTemplateService.getUtils(scope.template.Name);
                    scope.templateUrl = `partials/manage/ActionTemplate?type=${scope.template.Name}`;
                    scope.open = true;
                } else if (scope.open) {
                    scope.open = false;
                }
            };
        }
    };
});
})();
